import { GridCellProps } from '@progress/kendo-react-grid';
import { FC, useCallback } from 'react';
import GridCellBase, { useGridCellDisplayValue } from 'src/components/GridCellBase';
import useViewCheckbook from 'src/hooks/useViewCheckbook';

export const validateNumber = (value: string) => {
  if (Number(value) < 0) {
    return { color: '#94C947', backgroundColor: '#94c94747' };
  }
  return {};
};

const TotalAmountCell: FC<GridCellProps> = (props: GridCellProps) => {
  const { setHoldAmountData, toggleExpand } = useViewCheckbook();
  const { value, displayValue } = useGridCellDisplayValue(props);

  const handleClick = useCallback(() => {
    setHoldAmountData((prev) =>
      [...prev].map((item) => {
        if (item?.rowId === props.dataItem.rowId) {
          item.expanded = !props.dataItem.expanded;
        }
        return item;
      })
    );
    toggleExpand();
  }, [props.dataItem.expanded, props.dataItem.rowId, setHoldAmountData, toggleExpand]);

  return (
    <GridCellBase
      {...props}
      style={validateNumber(value)}
      title={displayValue}
      className="!text-right"
    >
      <button onClick={handleClick} className="text-link cursor-pointer underline">
        <span>{displayValue}</span>
      </button>
    </GridCellBase>
  );
};

export default TotalAmountCell;
